// extracted by mini-css-extract-plugin
export var chip = "_mt-0";
export var icon = "_mt-1";
export var remove = "_mt-2";
export var removeIcon = "_mt-3";